import React from "react";
import styled from "styled-components";

const Switch = (props: Props) => {
  const { id, name, isChecked, onChange, disabled } = props;

  const htmlFor = id || name;

  return (
    <Label htmlFor={htmlFor}>
      <Input
        readOnly={disabled}
        id={htmlFor}
        /* eslint-disable-next-line react/destructuring-assignment */
        aria-label={props["aria-label"]}
        type="checkbox"
        checked={isChecked}
        onChange={() => {
          if (!disabled) {
            onChange(!isChecked);
          }
        }}
      />
      <SwitchTrack aria-hidden="true" isChecked={isChecked} disabled={disabled}>
        <SwitchThumb isChecked={isChecked} disabled={disabled} />
      </SwitchTrack>
    </Label>
  );
};

type Props = {
  id?: string;
  "aria-label": string;
  name: string;
  isChecked: boolean;
  onChange: (boolean) => void;
  disabled?: boolean;
};

const Label = styled.label`
  display: block;
  margin-bottom: 0px;
`;

const Input = styled.input`
  border: 0px;
  clip: rect(0px, 0px, 0px, 0px);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0px;
  overflow: hidden;
  white-space: nowrap;
  position: absolute;
`;

const SwitchTrack = styled.span<{
  isChecked: boolean;
  disabled: boolean;
}>`
  background: ${({ theme, isChecked, disabled }) => {
    if (disabled) {
      return theme.colors.gray500;
    }
    if (isChecked) {
      return theme.colors.primary;
    }
    return theme.colors.gray300;
  }};
  display: inline-flex;
  justify-content: flex-start;
  box-sizing: content-box;
  cursor: pointer;
  border-radius: 1rem;
  padding: 2px;
  width: 1.875rem;
  height: 1rem;
  transition-property: background;
  transition-duration: 150ms;
`;

const SwitchThumb = styled.span<{
  isChecked: boolean;
  disabled: boolean;
}>`
  background: ${({ theme, disabled }) =>
    disabled ? theme.colors.gray200 : theme.colors.white};
  transform: translateX(${({ isChecked }) => (isChecked ? "14px" : 0)});
  transition-property: transform;
  transition-duration: 200ms;
  border-radius: inherit;
  width: 1rem;
  height: 1rem;
`;

export default Switch;
